/**
 * Static default app configuration
 * Used as fallback when get-ui-config API fails
 */
export const defaultAppConfig = {
  "commonConfig":{
    "clientName":"Demo",
    "hideOptionGroupLabels":true,
    "handleDim2SortingFromFrontend":false,
    "dateFormat":"MM/DD/YYYY",
    "dateFormatAlt":"MM/DD/YY",
    "calenderStartDay":"Sunday",
    "showSecondaryLogo":false,
    "showLogoInNavbar":true,
    "logoHeight":"32px",
    "logoWidth":"125px",
    "loginPageTextPart1":"Welcome to",
    "loginPageTextPart2":"Asper RGM",
    "width":1920,
    "limit":10,
    "offset":0,
    "lagList":[
      0,
      1
    ],
    "graphFontSize":13,
    "graphFontSizeAlt":13,
    "graphFontFamily":"'IBM Plex Sans', sans-serif",
    "graphLabelColorAlt":"#4E4C55",
    "graphLabelColor":"#433C4A",
    "units":{
      "currency":"$",
      "volume":"Eq Vol",
      "currencyText":"Dollar"
    },
    "filterFormat":{
      "dim1":{
        "ids":[

        ]
      },
      "dim2":{
        "ids":[

        ]
      }
    },
    "frequency":"W",
    "showCampignCalender":false,
    "showFullLabel":true,
    "decimalForPercentage":1,
    "decimalForNonPercentage":2,
    "enableAskAsper": true,
    "isEvalEnabled": true
  },
  "latestDateForDifferentRoutes":{
    "promo-score-card":"Promotion Data",
    "roi-analysis":"Promotion Data",
    "roi-tracker":"Promotion Data",
    "promo-recommendation":"Promotion Data",
    "default":"POS Data"
  },
  "screenDetailsWithRoutes":[
    {
      "label":"Home",
      "path":"home",
      "id":"home",
      "pageId":"home"
    },
    {
      "label":"Growth Analysis",
      "path":"promo/category-diagnostics/growth-analysis",
      "id":"ga",
      "pageId":"ga"
    },
    {
      "label":"Bump Report",
      "path":"promo/category-diagnostics/bump-report",
      "id":"br",
      "pageId":"br"
    },
    {
      "label":"Price Change",
      "path":"pricing/recommendation/price-change",
      "id":"pcn",
      "pageId":"pcn"
    },
    {
      "label":"Price Threshold",
      "path":"pricing/recommendation/price-threshold",
      "id":"pth",
      "pageId":"pth"
    },
    {
      "label":"Price Change Decomposition",
      "path":"pricing/recommendation/price-change-decomposition",
      "id":"pcd",
      "pageId":"pcd"
    },
    {
      "label":"Assortment /SKU Performance Ranking",
      "path":"pricing/analytics/assortment-performance-ranking",
      "id":"assr",
      "pageId":"assr"
    },
    {
      "label":"Price Point",
      "path":"pricing/analytics/price-point",
      "id":"pp",
      "pageId":"pp"
    },
    {
      "label":"Price Ladder",
      "path":"pricing/recommendation/price-ladder",
      "id":"pld",
      "pageId":"pld"
    },
    {
      "label":"Price Curve",
      "path":"pricing/recommendation/price-curve",
      "id":"pc",
      "pageId":"pc"
    },
    {
      "label":"Price Tracking",
      "path":"pricing/recommendation/price-tracking",
      "id":"pt",
      "pageId":"pt"
    },
    {
      "label":"Opportunity Identification",
      "path":"pricing/recommendation/opportunity-identification",
      "id":"oi",
      "pageId":"oi"
    },
    {
      "label":"Promo Scorecard",
      "path":"promo/analytics/promo-score-card",
      "id":"ps",
      "pageId":"ps"
    },
    {
      "label":"Investment & ROI Tracker",
      "path":"promo/analytics/roi-tracker",
      "id":"pl",
      "pageId":"pl"
    },
    {
      "label":"Promo ROI Analysis",
      "path":"promo/analytics/roi-analysis",
      "id":"pa",
      "pageId":"pa"
    },
    {
      "label":"Promo Recommendation",
      "path":"promo/analytics/promo-recommendation",
      "id":"pr",
      "pageId":"pr"
    },
    {
      "label":"Trade Promo Optimization V2",
      "path":"promo/analytics/tpo",
      "id":"tpo",
      "pageId":"tpo",
      "subRoutes":[
        {
          "suffix":"plan",
          "pageId":"plan"
        },
        {
          "suffix":"plan/:mode/:planId",
          "pageId":"viewUpdatePlan"
        },
        {
          "suffix":"tool/playbook",
          "pageId":"playbookTool"
        },
        {
          "suffix":"tool/promo-library",
          "pageId":"promoLibraryTool"
        },
        {
          "suffix":"report",
          "pageId":"report"
        }
      ]
    },
    {
      "label":"Pricing Simulator",
      "path":"pricing/recommendation/price-simulator",
      "id":"psr",
      "pageId":"psr"
    },
    {
      "label":"Pricing Simulator",
      "path":"pricing/recommendation/price-simulator/new",
      "id":"psr",
      "pageId":"psrNew"
    },
    {
      "label":"Pricing Simulator",
      "path":"pricing/recommendation/price-simulator/edit/:id",
      "id":"psr",
      "pageId":"psrEdit"
    },
    {
      "label":"Pricing Simulator",
      "path":"pricing/recommendation/price-simulator/view/:id",
      "id":"psr",
      "pageId":"psrView"
    },
    {
      "label":"Pricing Simulator",
      "path":"promo/category-diagnostics/pricing-simulator",
      "id":"psrV2",
      "pageId":"psrV2"
    },
    {
      "label":"Pricing Simulator ",
      "path":"promo/category-diagnostics/pricing-simulator/:mode/:projectId/scenario/:scenarioId",
      "id":"psr",
      "pageId":"psrV2Update"
    },
    {
      "label":"Pricing Simulator",
      "path":"promo/category-diagnostics/pricing-simulator/:mode/:projectId/scenario/:scenarioId",
      "id":"psr",
      "pageId":"psrV2View"
    },
    {
      "label":"Pricing Analytics",
      "path":"promo/category-diagnostics/pricing-analytics",
      "id":"psa",
      "pageId":"psa"
    },
    {
      "label":"Pricing Analytics",
      "path":"promo/category-diagnostics/pricing-analytics/:mode/:reportId",
      "id":"psa",
      "pageId":"psaUpdate"
    },
    {
      "label":"Pricing Analytics",
      "path":"promo/category-diagnostics/pricing-analytics/:mode/:reportId",
      "id":"psa",
      "pageId":"psaView"
    },
    {
      "label":"Best Weeks",
      "path":"promo/analytics/best-weeks",
      "id":"bw",
      "pageId":"bw"
    },
    {
      "label":"Assortment Planning",
      "path":"promo/analytics/assortment-planning",
      "id":"asp",
      "pageId":"asp"
    },
    {
      "label":"Base Volume Planning",
      "path":"promo/analytics/base-volume-planning",
      "id":"bvp",
      "pageId":"bvp"
    },
    {
      "label":"Scenario Decomposition",
      "path":"promo/category-diagnostics/scenario-decomposition",
      "id":"sd",
      "pageId":"sd"
    },
    {
      "label":"P&L Comparison",
      "path":"promo/category-diagnostics/pl-comparison",
      "id":"plc",
      "pageId":"plc"
    },
    {
      "label":"White space analysis",
      "path":"pricing/analytics/white-space-analysis",
      "id":"wsa",
      "pageId":"wsa"
    },
    {
      "label":"Executive Summary",
      "path":"executive-summary",
      "id":"es",
      "pageId":"es"
    },
    {
      "label":"P4P overview",
      "path":"assortment/p4p-overview",
      "id":"p4po",
      "pageId":"p4po"
    },
    {
      "label":"P4P Performance",
      "path":"assortment/p4p-performance",
      "id":"p4pp",
      "pageId":"p4pp"
    },
    {
      "label":"P4P Simulator",
      "path":"assortment/p4p-simulator",
      "id":"p4ps",
      "pageId":"p4ps"
    },
    {
      "label":"Drivers Of Profit Growth",
      "path":"trade-architecture/drivers-of-profit-growth",
      "id":"dpg",
      "pageId":"dpg"
    },
    {
      "label": "Admin Settings",
      "path": "admin",
      "id": "adminIndex",
      "pageId": "adminIndex"
    },
    {
      "label": "Cache management",
      "path": "admin/cache-management",
      "id": "cm",
      "pageId": "cm"
    },
    {
      "label": "Force Refresh",
      "path": "admin/force-refresh",
      "id": "fr",
      "pageId": "fr"
    },
    {
      "label": "Simulator Validation",
      "path": "admin/simulator-validation",
      "id": "sv",
      "pageId": "sv"
    },
    {
      "label": "App Lightup",
      "path": "admin/applightup",
      "id": "al",
      "pageId": "al"
    },
    {
      "label": "Migration History",
      "path": "admin/migration-history",
      "id": "mh",
      "pageId": "mh"
    },
    {
      "label": "DE refresh jobs",
      "path": "admin/de-refresh-jobs",
      "id": "drj",
      "pageId": "drj"
    }
  ],
  "screens":[
    {
      "label":"Category Performance",
      "path":[
        "promo/category-diagnostics"
      ],
      "options":[
        {
          "label":"Opportunity Assessment",
          "basePath":"promo/category-diagnostics",
          "items":[
            {
              "label":"Drivers & Drags",
              "path":"growth-analysis",
              "id":"ga"
            },
            {
              "label":"Bump Report",
              "path":"bump-report",
              "id":"br"
            }
          ]
        },
        {
          "label":"Scenario Building",
          "basePath":"promo/category-diagnostics",
          "items":[
            {
              "label":"Holistic RGM Simulator",
              "path":"pricing-simulator",
              "id":"psrv2"
            },
            {
              "label":"Scenario Decomposition",
              "path":"scenario-decomposition",
              "id":"sd"
            },
            {
              "label":"P&L Comparison",
              "path":"pl-comparison",
              "id":"plc"
            }
          ]
        }
      ]
    },
    {
      "label":"Strategic Pricing",
      "path":[
        "pricing/recommendation"
      ],
      "options":[
        {
          "label":"Opportunity Assessment",
          "basePath":"pricing/recommendation",
          "items":[
            {
              "label":"Price Change",
              "path":"price-change",
              "id":"pcn"
            },
            {
              "label":"Price Threshold",
              "path":"price-threshold",
              "id":"pth"
            },
            {
              "label":"Price Change Decomposition",
              "path":"price-change-decomposition",
              "id":"pcd"
            },
            {
              "label":"Price Ladder",
              "path":"price-ladder",
              "id":"pld"
            },
            {
              "label":"Price Curve",
              "path":"price-curve",
              "id":"pc"
            },
            {
              "label":"Price Tracking",
              "path":"price-tracking",
              "id":"pt"
            },
            {
              "label":"Opportunity Identification",
              "path":"opportunity-identification",
              "id":"oi"
            }
          ]
        },
        {
          "label":"Scenario Building",
          "basePath":"pricing/recommendation",
          "items":[
            {
              "label":"Price Simulator",
              "path":"price-simulator",
              "id":"psr"
            }
          ]
        }
      ]
    },
    {
      "label":"Portfolio Architecture",
      "path":[
        "pricing/analytics"
      ],
      "options":[
        {
          "label":"PPA Opportunity",
          "basePath":"pricing/analytics",
          "items":[
            {
              "label":"Price Point",
              "path":"price-point",
              "id":"pp"
            },
            {
              "label":"Pack Architecture",
              "path":"price-pack-architecture",
              "id":"ppa"
            },
            {
              "label":"Weight Elasticity Measure",
              "path":"",
              "id":"wem",
              "disabled":true
            },
            {
              "label":"Demand Transfer",
              "path":"demand-transference",
              "id":"dt",
              "disabled":true
            },
            {
              "label":"White Space Analysis",
              "path":"white-space-analysis",
              "id":"wsa"
            },
            {
              "label":"Price Index",
              "path":"",
              "id":"pi",
              "disabled":true
            }
          ]
        },
        {
          "label":"Assortment Opportunity",
          "basePath":"pricing/analytics",
          "items":[
            {
              "label":"Assortment /SKU Performance Ranking",
              "path":"assortment-performance-ranking",
              "id":"assr"
            },
            {
              "label":"SKU Report",
              "path":"",
              "id":"skur",
              "disabled":true
            }
          ]
        },
        {
          "label":"Scenario Building",
          "basePath":"pricing/analytics",
          "items":[
            {
              "label":"PPA Simulator",
              "path":"price-pack-simulator",
              "id":"ppas"
            }
          ]
        }
      ]
    },
    {
      "label":"Trade Promotion Excellence",
      "icon":"percentage",
      "path":[
        "promo/analytics"
      ],
      "options":[
        {
          "label":"Opportunity Assessment",
          "basePath":"promo/analytics",
          "items":[
            {
              "label":"Promo Scorecard",
              "path":"promo-score-card",
              "id":"ps"
            },
            {
              "label":"Investment & ROI Tracker",
              "path":"roi-tracker",
              "id":"pl"
            },
            {
              "label":"Promo ROI Analysis",
              "path":"roi-analysis",
              "id":"pa"
            },
            {
              "label":"Best Weeks",
              "path":"best-weeks",
              "id":"bw"
            }
          ]
        },
        {
          "label":"Scenario Building",
          "basePath":"promo/analytics",
          "items":[
            {
              "label":"Assortment Planning",
              "path":"assortment-planning",
              "id":"asp"
            },
            {
              "label":"Base Volume Planning",
              "path":"base-volume-planning",
              "id":"bvp"
            },
            {
              "label":"Trade Promo Optimization",
              "path":"tpo",
              "id":"tpo"
            },
            {
              "label":"Commercial Policy Simulator",
              "path":"commercial-policy-simulator",
              "id":"cps"
            },
            {
              "label":"Trade v0",
              "path":"promo-recommendation",
              "id":"pr",
              "grayedOut":true
            }
          ]
        }
      ]
    },
    {
      "label":"Trade Architecture",
      "icon":"appstore",
      "path":[
        "trade-architecture",
        "assortment"
      ],
      "options":[
        {
          "label":"Profit Pool",
          "basePath":"trade-architecture",
          "items":[
            {
              "label":"Profit Pool Overview",
              "path":"profit-pool-overview",
              "id":"ppo"
            },
            {
              "label":"Drivers Of Profit Growth",
              "path":"drivers-of-profit-growth",
              "id":"dpg"
            }
          ]
        },
        {
          "label":"Pay4Performance",
          "basePath":"assortment",
          "items":[
            {
              "label":"P4P Overview",
              "path":"p4p-overview",
              "id":"p4po"
            },
            {
              "label":"P4P Performance",
              "path":"p4p-performance",
              "id":"p4pp"
            }
          ]
        },
        {
          "label":"Scenario Building",
          "basePath":"assortment",
          "items":[
            {
              "label":"P4P Simulator",
              "path":"p4p-simulator",
              "id":"p4ps"
            }
          ]
        }
      ]
    }
  ],
  "globalFilter": {
    "presetConfig": {
      "disablePresetFilter": false,
      "presetEnabledRoutes": {
        "all": true
      }
    },
    "availableFrequenciesList": [
      {
        "key": "W",
        "label": "Week"
      }
    ],
    "globalFilterChangingRoutes": {},
    "limit": 50,
    "numberOfDimensions": 2,
    "selectionAllowed": {
      "promo-recommendation": {
        "dim2": {
          "Retailer": 1
        }
      }
    },
    "allSelectedLimit": 15,
    "timePeriodScreenMapping": {
      "default": [
        "4W",
        "12W",
        "26W",
        "52W",
        "YTD",
        "CUSTOM DATE"
      ],
      "bump-report": [
        "52W",
        "104W",
        "156W",
        "YTD",
        "CUSTOM DATE"
      ]
    },
    "defaultPeriod": [
      "52W"
    ],
    "applyFilterApiPostFormat": {
      "jsonstring_dim1": "{}",
      "jsonstring_dim2": "{}"
    },
    "defaultPreviousIdObject": {
      "dim1": [
        "attr",
        "attr"
      ],
      "dim2": [
        "attr",
        "attr"
      ]
    },
    "defaultIdObject": {
      "dim1": {
        "ids": []
      },
      "dim2": {
        "ids": []
      }
    },
    "defaultAttrIdObject": {
      "attr": {
        "dim1": {
          "ids": []
        },
        "dim2": {
          "ids": []
        }
      }
    },
    "promoScoreCardDefault": {
      "Category": "TOTAL BARS",
      "Retailer": "Kroger Corp w Roundys"
    },
    "retainFiltersAcrossFeatures": false,
    "PromoScoreCardDefaultObj": {
      "dim1": {
        "Category": {
          "inclusion": [
            {
              "dimension": "dim1",
              "isActive": true,
              "attributeType": "Category",
              "attributeDesc": "TOTAL BARS",
              "attributeExId": "TOTAL BARS"
            }
          ]
        }
      },
      "dim2": {
        "Retailer": {
          "inclusion": [
            {
              "dimension": "dim2",
              "isActive": true,
              "attributeType": "Retailer",
              "attributeDesc": "Kroger Corp w Roundys",
              "attributeExId": "Kroger Corp w Roundys"
            }
          ]
        }
      }
    }
  },
  "priceSimulator": {
    "dataSources": [
      {
        "label": "Projected Consumption",
        "value": "iri"
      },
      {
        "label": "Consumption Actuals",
        "value": "l52_weeks"
      },
      {
        "label": "Financials",
        "value": "financials"
      }
    ],
    "allScenariosTableLimit": 500,
    "a": 10,
    "opportunityIdentificationTiles": [
      {
        "key": "recommendation",
        "label": "Recommendation"
      },
      {
        "key": "input",
        "label": "Input"
      },
      {
        "key": "output",
        "label": "Output"
      }
    ],
    "cascadingColumns": [
      "COGS Rate",
      "List Price",
      "Everyday Retail Price"
    ],
    "levels": [
      "product",
      "retailer"
    ],
    "inputKeyMapping": {
      "cogs": "COGS Rate",
      "lp": "List Price",
      "rp": "Everyday Retail Price",
      "acv": "ACV Distribution",
      "oi": "OI Rate",
      "non_oi": "Non OI Rate",
      "promo_trade_spends": "Promo Trade Rate Spends",
      "tr": "Trade Rate",
      "cf": "Comp Follow"
    },
    "outputKeyMapping": {
      "volume": {
        "label": "New Volume",
        "pre": "",
        "pos": ""
      },
      "volume_old": {
        "label": "Current Volume",
        "pre": "",
        "pos": ""
      },
      "vlmChg": {
        "label": "Volume Chg %",
        "pre": "",
        "pos": "%"
      },
      "units": {
        "label": "New Units",
        "pre": "",
        "pos": ""
      },
      "units_old": {
        "label": "Current Units",
        "pre": "",
        "pos": ""
      },
      "unitsChg": {
        "label": "Units Chg %",
        "pre": "",
        "pos": "%"
      },
      "rsv": {
        "label": "New RSV",
        "pre": "$",
        "pos": ""
      },
      "rsv_old": {
        "label": "Current RSV",
        "pre": "$",
        "pos": ""
      },
      "rsvChg": {
        "label": "RSV Chg %",
        "pre": "",
        "pos": "%"
      },
      "gsv": {
        "label": "New GSV",
        "pre": "$",
        "pos": ""
      },
      "gsv_old": {
        "label": "Current GSV",
        "pre": "$",
        "pos": ""
      },
      "gsvChg": {
        "label": "GSV Chg %",
        "pre": "",
        "pos": "%"
      },
      "nsv": {
        "label": "New NSV",
        "pre": "$",
        "pos": ""
      },
      "nsv_old": {
        "label": "Current NSV",
        "pre": "$",
        "pos": ""
      },
      "nsvChg": {
        "label": "NSV Chg %",
        "pre": "",
        "pos": "%"
      },
      "gmac": {
        "label": "New GMAC",
        "pre": "$",
        "pos": ""
      },
      "gmac_old": {
        "label": "Current GMAC",
        "pre": "$",
        "pos": ""
      },
      "gmacChg": {
        "label": "GMAC Chg %",
        "pre": "",
        "pos": "%"
      },
      "rtMg": {
        "label": "New Retail Margin %",
        "pre": "",
        "pos": "%"
      },
      "rtMg_old": {
        "label": "Current Retail Margin %",
        "pre": "",
        "pos": "%"
      },
      "rtMgPcChg": {
        "label": "Retail Margin Chg %",
        "pre": "",
        "pos": "%"
      },
      "retailer_profit": {
        "label": "New Retail Profit",
        "pre": "",
        "pos": ""
      },
      "retailer_profit_old": {
        "label": "Current Retail Profit",
        "pre": "",
        "pos": ""
      },
      "rtPfChg": {
        "label": "Retail Profit Chg %",
        "pre": "",
        "pos": "%"
      },
      "netRpChg": {
        "label": "Net Effective Price % Chg",
        "pre": "",
        "pos": "%"
      },
      "mgPc": {
        "label": "New Margin %",
        "pre": "",
        "pos": "%"
      },
      "mgPc_old": {
        "label": "Current Margin %",
        "pre": "",
        "pos": "%"
      },
      "mgPcChg": {
        "label": "Margin Chg %",
        "pre": "",
        "pos": "%"
      },
      "profitPool": {
        "label": "New Profit Pool",
        "pre": "",
        "pos": "%"
      },
      "profitPool_old": {
        "label": "Current Profit Pool",
        "pre": "",
        "pos": "%"
      },
      "profitPoolChg": {
        "label": "Profit Pool Chg %",
        "pre": "",
        "pos": "$"
      },
      "oi_cp": {
        "label": "Current OI Rate",
        "pre": "",
        "pos": "%"
      },
      "oi_np": {
        "label": "New OI Rate",
        "pre": "",
        "pos": ""
      },
      "oi_pc": {
        "label": "OI Rate Chg %",
        "pre": "",
        "pos": "%"
      },
      "non_oi_cp": {
        "label": "Current Non OI Rate",
        "pre": "",
        "pos": ""
      },
      "non_oi_np": {
        "label": "New Non OI Rate",
        "pre": "",
        "pos": ""
      },
      "non_oi_pc": {
        "label": "Non OI Rate Chg %",
        "pre": "",
        "pos": "%"
      },
      "promo_trade_spends_cp": {
        "label": "Current Promo Trade Rate Spends",
        "pre": "",
        "pos": ""
      },
      "promo_trade_spends_np": {
        "label": "Current Promo Trade Rate Spends",
        "pre": "",
        "pos": ""
      },
      "promo_trade_spends_pc": {
        "label": "Promo Trade Rate Spends Chg %",
        "pre": "",
        "pos": "%"
      },
      "tr_cp": {
        "label": "Current Trade Rate",
        "pre": "",
        "pos": ""
      },
      "tr_np": {
        "label": "New Trade Rate",
        "pre": "",
        "pos": ""
      },
      "tr_pc": {
        "label": "Trade Rate Chg %",
        "pre": "",
        "pos": "%"
      }
    },
    "recommendationKeyMapping": {
      "recommended_list_price": {
        "label": "New list price recom",
        "pre": "$",
        "pos": ""
      },
      "role": {
        "label": "Role",
        "pre": "",
        "pos": ""
      },
      "strategy": {
        "label": "Strategy",
        "pre": "",
        "pos": ""
      },
      "mix": {
        "label": "Mix",
        "pre": "",
        "pos": ""
      },
      "growth": {
        "label": "Growth",
        "pre": "",
        "pos": ""
      },
      "gap": {
        "label": "Gap",
        "pre": "",
        "pos": ""
      },
      "cogs": {
        "label": "COGs",
        "pre": "",
        "pos": "%"
      },
      "list_to_retail": {
        "label": "List to Retail",
        "pre": "",
        "pos": ""
      },
      "bpe": {
        "label": "BPE",
        "pre": "",
        "pos": ""
      },
      "ppe": {
        "label": "PPE",
        "pre": "",
        "pos": ""
      },
      "margin": {
        "label": "Margin",
        "pre": "",
        "pos": "%"
      },
      "growth_vs_category": {
        "label": "Gowth vs Category",
        "pre": "",
        "pos": "%"
      },
      "pl_vs_category": {
        "label": "PL vs Category",
        "pre": "",
        "pos": "%"
      },
      "threshold": {
        "label": "Threshold",
        "pre": "",
        "pos": ""
      },
      "comp_index": {
        "label": "Comp. Index",
        "pre": "",
        "pos": ""
      },
      "curve_index": {
        "label": "Curve Index",
        "pre": "",
        "pos": ""
      },
      "cogs_realization": {
        "label": "COGS & Realization",
        "pre": "",
        "pos": ""
      },
      "cogs_forecast": {
        "label": "COGS Forecast",
        "pre": "",
        "pos": "%"
      },
      "net_to_retail": {
        "label": "Net to Retail",
        "pre": "",
        "pos": "%"
      },
      "gross_to_net": {
        "label": "Gross to Net",
        "pre": "",
        "pos": "%"
      },
      "recommended_retail_price": {
        "label": "Recommended Ratail Price",
        "pre": "",
        "pos": "%"
      },
      "recommended_trade_rate": {
        "label": "Recommended Trade Rate",
        "pre": "",
        "pos": "%"
      }
    },
    "defaultKpiMetrics": [
      1,
      2,
      3,
      4,
      5
    ],
    "kpiMetrics": [
      {
        "key": 1,
        "value": "volume_sales",
        "name": "Nutrifuel Volume Sales",
        "pre": "",
        "post": ""
      },
      {
        "key": 2,
        "value": "value_sales",
        "name": "Nutrifuel Value Sales ($)",
        "pre": "$",
        "post": ""
      },
      {
        "key": 3,
        "value": "profit_abs",
        "name": "Nutrifuel Profit Abs ($)",
        "pre": "$",
        "post": ""
      },
      {
        "key": 4,
        "value": "margin_percent",
        "name": "Nutrifuel Margin (%)",
        "pre": "",
        "post": "%"
      },
      {
        "key": 5,
        "value": "trade_rate_percent",
        "name": "Nutrifuel Trade Rate (%)",
        "pre": "",
        "post": "%"
      },
      {
        "key": 6,
        "value": "retailer_margin_percent",
        "name": "Nutrifuel Retailer Margin (%)",
        "pre": "",
        "post": "%"
      },
      {
        "key": 7,
        "value": "gross_profit",
        "name": "Nutrifuel Gross Profit ($)",
        "pre": "$",
        "post": ""
      },
      {
        "key": 8,
        "value": "retailer_profit",
        "name": "Nutrifuel Retailer Profit ($)",
        "pre": "$",
        "post": ""
      },
      {
        "key": 9,
        "value": "gross_sales",
        "name": "Nutrifuel Gross Sales ($)",
        "pre": "$",
        "post": ""
      },
      {
        "key": 10,
        "value": "net_sales",
        "name": "Nutrifuel Net Sales($)",
        "pre": "$",
        "post": ""
      },
      {
        "key": 11,
        "value": "total_volume",
        "name": "Total Volume Sales",
        "pre": "$",
        "post": ""
      },
      {
        "key": 12,
        "value": "total_value",
        "name": "Total Value Sales($)",
        "pre": "$",
        "post": ""
      },
      {
        "key": 13,
        "value": "net_retail_price_change",
        "name": "Nutrifuel Net Retailer Price % Chg",
        "pre": "",
        "post": "%"
      }
    ],
    "addPortfolioUpdateKpis": [
      {
        "key": "volume",
        "value": "",
        "label": "Volume",
        "rval": "",
        "percentChange": ""
      },
      {
        "key": "value",
        "value": "",
        "label": "Value",
        "rval": "",
        "percentChange": ""
      },
      {
        "key": "units",
        "value": "",
        "label": "Units",
        "rval": "",
        "percentChange": ""
      },
      {
        "key": "trade_rate",
        "value": "",
        "label": "Trade Rate %",
        "rval": "",
        "percentChange": ""
      },
      {
        "key": "list_price",
        "value": "",
        "label": "List Price per unit",
        "rval": "",
        "percentChange": ""
      },
      {
        "key": "retail_price",
        "value": "",
        "label": "Retail Price per unit",
        "rval": "",
        "percentChange": ""
      },
      {
        "key": "acv",
        "value": "",
        "label": "ACV Distribution %",
        "rval": "",
        "percentChange": ""
      },
      {
        "key": "cogs",
        "value": "",
        "label": "COGS per unit",
        "rval": "",
        "percentChange": ""
      },
      {
        "key": "base_elasticity",
        "value": "",
        "label": "Base Elasticity",
        "rval": "",
        "percentChange": ""
      },
      {
        "key": "acv_elasticity",
        "value": "",
        "label": "Acv Elasticity",
        "rval": "",
        "percentChange": ""
      }
    ],
    "quarterMetricKeyMapping": [
      {
        "name": "Volume",
        "value": "volume",
        "pre": "",
        "post": ""
      },
      {
        "name": "Revenue",
        "value": "revenue",
        "pre": "$",
        "post": ""
      },
      {
        "name": "Profit",
        "value": "profit",
        "pre": "$",
        "post": ""
      },
      {
        "name": "Trade Rate Percent",
        "value": "tradeRatePercent",
        "pre": "",
        "post": "%"
      },
      {
        "name": "Retailer Margin",
        "value": "retailerMargin",
        "pre": "",
        "post": ""
      }
    ]
  },
  "pricingSimulator": {
    "hidePriceEffectiveDateProperty": true,
    "enableAnalyticsTab": true,
    "enableBulkUpload": false,
    "indexPageTableLimit": 50,
    "scenarioFilterOffsetLimit": 50,
    "scenarioPerProjectLimit": 10,
    "scenarioTableLimit": 500,
    "analyticsChartLimit": 100,
    "comparisonTableLimit": 50,
    "dimAttributesLimit": 4,
    "characterLimit": {
      "kpiTileCharLimit": 22,
      "kpiCompareCardLimit": 30
    },
    "enablePrivatePublicToggle": false,
    "enableMicroInfoForTables": false,
    "disableExport": true,
    "indexTableFixedColumns": [
      {
        "label": "Project Name",
        "key": "projectName",
        "sortKey": "project_name"
      },
      {
        "label": "Created By",
        "key": "createdBy",
        "sortKey": "created_by"
      },
      {
        "label": "Status",
        "key": "status"
      },
      {
        "label": "Last Updated",
        "key": "lastUpdated",
        "sortKey": "updated_at"
      },
      {
        "label": "Simulation Period",
        "key": "simulationPeriod"
      }
    ],
    "analyticsBaseScenarioFixedColumns": [
      {
        "label": "Project Name",
        "key": "projectName",
        "sortKey": "project_name"
      },
      {
        "label": "Created By",
        "key": "createdBy",
        "sortKey": "created_by"
      },
      {
        "label": "Status",
        "key": "status"
      }
    ],
    "analyticsTableColumns": [
      {
        "label": "Report Name",
        "key": "reportName",
        "sortKey": "report_name"
      },
      {
        "label": "Base Scenario",
        "key": "baseScenario",
        "sortKey": "base_scenario"
      },
      {
        "label": "Created By",
        "key": "createdBy",
        "sortKey": "created_by"
      },
      {
        "label": "Last Updated",
        "key": "lastUpdated",
        "sortKey": "updated_at"
      },
      {
        "label": "Date Created",
        "key": "dateCreated",
        "sortKey": "created_at"
      }
    ],
    "projectStatuses": {
      "ACTIVE": {
        "label": "Active",
        "colorType": "success"
      },
      "DRAFT": {
        "label": "Draft",
        "colorType": "processing"
      },
      "SEND_FOR_APPROVAL": {
        "label": "Send For Approval",
        "colorType": "processing"
      },
      "APPROVED": {
        "label": "Approved",
        "colorType": "processing"
      },
      "SETUP": {
        "label": "Setup",
        "colorType": "processing"
      },
      "IN_PROGRESS": {
        "label": "In-Progress",
        "colorType": "processing"
      },
      "EXPIRED": {
        "label": "Expired",
        "colorType": "default"
      },
      "ERROR": {
        "label": "Error",
        "colorType": "error"
      },
      "INVALID": {
        "label": "Invalid",
        "colorType": "error"
      }
    },
    "projectDataSource": [
      {
        "label": "Actuals",
        "value": "depletion_data"
      }
    ],
    "simulatedPeriodItems": [
      {
        "label": "Custom Date",
        "value": "custom_date",
        "dateArray": null
      },
      {
        "label": "Current Year",
        "value": "current_year",
        "dateArray": [
          "01-05-2025",
          "12-28-2025"
        ]
      },
      {
        "label": "Financial Year",
        "value": "financial_year",
        "dateArray": [
          "03-02-2025",
          "02-22-2026"
        ]
      }
    ],
    "iconsMappings": {
      "Elasticity": "BorderOuterOutlined",
      "BaseInput": "BorderlessTableOutlined",
      "COGS": "DollarOutlined",
      "Distributor": "BuildOutlined",
      "Distributor P&L": "BuildOutlined",
      "FOB": "ClusterOutlined",
      "P & L": "LineChartOutlined",
      "Price Tree": "MoneyCollectOutlined",
      "Promotions": "BoxPlotOutlined",
      "Retailer P&L": "LineChartOutlined",
      "Sales": "AreaChartOutlined",
      "Taxes": "BlockOutlined",
      "Volume": "ExperimentOutlined",
      "Others": "UngroupOutlined",
      "Product": "GoldOutlined",
      "Geo": "ExpandOutlined",
      "Dollar Impact": "DollarOutlined",
      "Standard Increase Metrics": "ToTopOutlined",
      "EQV Metrics": "BlockOutlined"
    },
    "categoryMovementKpis": [
      {
        "label": "Volume Impact",
        "value": "volume",
        "yAxisLabel": "Vol",
        "xAxisLabel": "Retailer Vol"
      },
      {
        "label": "Sales Impact",
        "value": "sales",
        "yAxisLabel": "Sales $",
        "xAxisLabel": "Retailer Sales $"
      }
    ]
  },
  "priceChange": {
    "limit": 60,
    "dimensionConfig": {
      "excludedDimensions": [],
      "defaultDimension": "Manufacturer"
    },
    "timePeriodOptions": [
      {
        "label": "YA",
        "value": "year_ago"
      },
      {
        "label": "Prior Period",
        "value": "prior_period"
      },
      {
        "label": "Custom Period",
        "value": "custom"
      }
    ],
    "absTileData": [
      {
        "key": "abs",
        "label": "Abs"
      },
      {
        "key": "percentage",
        "label": "%"
      }
    ],
    "kpiListData": [
      {
        "key": "avg_price",
        "label": "Avg Price",
        "value": "average",
        "dataKey": "avg_price"
      },
      {
        "key": "base_price",
        "label": "Base Price",
        "value": "base",
        "dataKey": "base_price"
      }
    ],
    "volTileData": [
      {
        "key": "units",
        "label": "PU",
        "value": "units",
        "dataKey": "units",
        "tooltip": "Per Unit"
      },
      {
        "key": "vol",
        "label": "PEQ",
        "value": "vol",
        "dataKey": "volume",
        "tooltip": "Per Eq Volume"
      }
    ],
    "salesTileData": [
      {
        "key": "sales",
        "label": "Sales"
      },
      {
        "key": "incremental",
        "label": "Incremental"
      },
      {
        "key": "promo",
        "label": "Promo"
      }
    ],
    "salesAttributionChart": {
      "colorList": [
        "#10AB5E",
        "#DC3826"
      ],
      "colorListType2": [
        "#758BEE",
        "#758BEE"
      ],
      "profitPoolColor": [
        "#826FD0",
        "#826FD0"
      ],
      "backGroundColor": "rgba(0, 0, 0, 0.02)"
    },
    "salesAttributionDrillDownChartKeyValueMapping": {
      "feature_&_display": "Feature & Display",
      "Feature & Display": "feature_&_display"
    },
    "salesAttributionChart2Limit": 20
  },
  "growthAnalysis": {
    "limit": 60,
    "dimensionConfig": {
      "excludedDimensions": [],
      "defaultDimension": "Vendor"
    },
    "absTileData": [
      {
        "key": "abs",
        "label": "Abs"
      },
      {
        "key": "percentage",
        "label": "%"
      }
    ],
    "subTileData": [
      {
        "label": "PU",
        "key": "PU"
      },
      {
        "label": "PEQ",
        "key": "PEQ"
      }
    ],
    "volTileData": [
      {
        "key": "val",
        "label": "Dollars",
        "value": "val",
        "dataKey": "value"
      },
      {
        "key": "vol",
        "label": "Eq Volume",
        "value": "vol",
        "dataKey": "volume"
      },
      {
        "key": "units",
        "label": "Units",
        "value": "units",
        "dataKey": "units"
      }
    ],
    "showTotal": true,
    "currentYearLabel": "CY",
    "yearAgoLabel": "YA",
    "trendChartDropdownData": [
      {
        "key": "sales_volume",
        "label": "Sales Volume",
        "value": "sales_volume",
        "dataKey": "sales_volume"
      },
      {
        "key": "sales",
        "label": "Sales $",
        "value": "sales",
        "dataKey": "sales"
      },
      {
        "key": "average_price",
        "label": "Average Price",
        "value": "average_price",
        "dataKey": "average_price"
      },
      {
        "key": "base_price",
        "label": "Base Price",
        "value": "base_price",
        "dataKey": "base_price"
      },
      {
        "key": "acv",
        "label": "%ACV",
        "value": "acv",
        "dataKey": "acv"
      },
      {
        "key": "avg_items",
        "label": "Avg. no. of items",
        "value": "avg_items",
        "dataKey": "avg_items"
      },
      {
        "key": "tdp",
        "label": "TDP",
        "value": "tdp",
        "dataKey": "tdp"
      }
    ],
    "salesTileData": [
      {
        "key": "sales",
        "label": "Sales"
      },
      {
        "key": "incremental",
        "label": "Incremental"
      },
      {
        "key": "promo",
        "label": "Promo"
      }
    ],
    "graphExportHeaderMapping": {
      "promo": [
        "Non-promo",
        "Promo"
      ],
      "incremental": [
        "Base",
        "Incremental"
      ],
      "sales": [
        "Sales Change"
      ]
    },
    "depletionDropdownData": [
      {
        "value": "frontline_sales",
        "dataKey": "frontline_sales",
        "key": "frontline_sales",
        "label": "Frontline Sales"
      },
      {
        "value": "net_sales",
        "dataKey": "net_sales",
        "key": "net_sales",
        "label": "Net Sales"
      }
    ],
    "tableKeyUnitMapping": {
      "Market Share CY": {
        "unit": "%",
        "label": "Market Share CY",
        "includePercentageChange": false
      },
      "Market Share YA": {
        "unit": "%",
        "label": "Market Share YA",
        "includePercentageChange": false
      },
      "ACV CY": {
        "unit": "%",
        "label": "Wtd. Avg ACV %",
        "includePercentageChange": false
      },
      "ACV YA": {
        "unit": "%",
        "label": "Wtd. Avg ACV % YA",
        "includePercentageChange": false
      }
    },
    "salesAttributionChart": {
      "colorList": [
        "#10AB5E",
        "#DC3826"
      ],
      "colorListType2": [
        "#758BEE",
        "#758BEE"
      ],
      "profitPoolColor": [
        "#826FD0",
        "#826FD0"
      ],
      "backGroundColor": "rgba(0, 0, 0, 0.02)"
    },
    "salesAttributionDrillDownChartKeyValueMapping": {
      "feature_&_display": "Feature & Display",
      "Feature & Display": "feature_&_display"
    },
    "salesAttributionChart2DisabledItems": [
      "unexplained"
    ],
    "salesAttributionChart2Limit": 50
  },
  "bumpReport": {
    "mainHeader": "Bump Report",
    "groupByKey": "groupBy",
    "enablePromoCalender": true,
    "isPromoUpliftPercentValue": false,
    "promoTypeColorMapping": {
      "tpr/scan": {
        "label": "TPR/Scan",
        "color": "#69D4E8"
      },
      "feature ad": {
        "label": "Feature Ad",
        "color": "#3394A3"
      },
      "display": {
        "label": "Display",
        "color": "#E469B2"
      },
      "feature_display_tpr": {
        "label": "Feature_Display_TPR",
        "color": "#E6875E"
      },
      "display_tpr": {
        "label": "Display_TPR",
        "color": "#293BB8"
      }
    }
  },
  "tradePromoOptimization": {
    "indexPageTableLimit": 50,
    "offerDataDropdownLimit": 100,
    "enableAskAsper": true,
    "enableRetainOverride": true
  },
  "promoRecommendation": {
    "enableAskAsper": true
  }
};
